import { render } from "./MenuViewer.vue?vue&type=template&id=26f72a63&scoped=true"
import script from "./MenuViewer.vue?vue&type=script&lang=js"
export * from "./MenuViewer.vue?vue&type=script&lang=js"

import "./MenuViewer.vue?vue&type=style&index=0&id=26f72a63&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f72a63"]])

export default __exports__